<div class="div_venue div_division">
  <div class="pos-title-header">
    <label class="lbl_top">{{'DIVISION.DIVISIONS' | translate}}</label>
    <button class="create_btn responsive_btn" (click)="createDivision()">
      <span class="hide_mobile">{{'CREATE' | translate}}</span>
      <i class="show_mobile pi pi-plus-circle"></i>
    </button>
  </div>
  <div class="cards_div_wrapper">
    <p-progressSpinner class="w-100 text-center pos_spiner" *ngIf="spinner"></p-progressSpinner>
    <div *ngFor="let division of listDivisions" class="division-div">
      <div>
        <span>
          <div class="menu_dropdown_helper pe-0 pt-0" #icon (click)=" menu1.toggle($event)"></div>
          <i class="pi pi-ellipsis-v spam-menu manager-emp-menu" (click)="icon.click()"></i>
          <p-menu #menu1 class="edit-menu header-menu" [popup]="true" [model]="items[division.id]"></p-menu>
        </span>
      </div>
      <div class="d-flex flex-row justify-content-start card-content">
        <div class="img-container">
          <img class="division-img" [src]="imagePath" alt="division-img">
        </div>
        <div class="d-flex flex-column division-props">
          <label class="w-100 division-name ellipsis" title="{{division.name}}">{{division.name}}</label>
          <label class="w-100 division-printer-name ellipsis" title="{{division.printerName}}">
            <img src="assets/icons/print_24px.svg" alt="printer" class="me-1">
            {{division.printerName}}</label>
        </div>
      </div>
    </div>
  </div>
</div>
